import { temporarilyNotSupport } from '../../utils'

// AI推理
export const getInferenceEnvInfo = /* @__PURE__ */ temporarilyNotSupport('getInferenceEnvInfo')
export const createInferenceSession = /* @__PURE__ */ temporarilyNotSupport('createInferenceSession')
